export { CalendarAlt as default } from './CalendarAlt';
